export default __webpack_public_path__ + "static/media/courier.151c07a1.jpg";